<template>
    <v-list-item to="/notifications">
        <v-list-item-action>
            <v-icon>mdi-bell-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title class="mt-n4">
                <v-badge
                    color="red"
                    :content="unread > 99? '99+': unread"
                    :value="unread"
                    inline>
                    Notifications
                </v-badge>
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['getNotifications']),
        unread() {
            return this.getNotifications.reduce((acc, item) => item.isAcknowledge ? acc : acc + 1, 0);
        }
    }
}
</script>

<style>

</style>